export default "__VITE_ASSET__1e22f21d__"